// extracted by mini-css-extract-plugin
export default {"container":"Home_container__fRasM","header":"Home_header__IzhAa","logo":"Home_logo__l2GCZ","footer":"Home_footer__tr65j"};